// Set negative margin on 100vw blocks on screen size > breakpoint.sm, set margin = 0 on screen size < breakpoint.sm

//Do not run in episer edit mode
if (!$('body').data('editmode')) {
    
    var breakpoints = {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1260
    };

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    $.fn.setFullWidthMargin = function () {
        var windowWidth = $(window).width();

        $('#main-content .block__full-width').each(function() {
            // Reset inline margin to measure the element's natural position
            $(this).css('margin-left', '');
            var elementOffset = $(this).offset().left;
            $(this).css({'margin-left': -elementOffset, 'opacity': 1, 'width': windowWidth});
        });
    };

    if (viewportWidth > breakpoints.sm) {
        $(this).setFullWidthMargin();
    }
    else {
        $(this).setFullWidthMargin();
    }

    $(window).resize(function() {
        $(this).setFullWidthMargin();
    });

    //Make sure the event triggers at least once
    $(window).on('load', function () {
        $(window).trigger('resize');
    });
}
